import { ScopePair as ApiScopePair } from "@/api/__generated__/schemas";
import { mapToOrganizationReference } from "@/mappers/organization.mappers";
import { mapToPlatformReference } from "@/mappers/platform.mappers";
import { ScopePair } from "@/types/scope.types";

/**
 * Map one caller-visible `(platform, federation)` pair from a REST list row's
 * `scopes` field to the domain `ScopePair`. Accepts both DTO flavours — the
 * nullable-sided `ScopePair` (single-pair entities) and `ScopePairRef` (users /
 * clubs, both sides required), which is structurally assignable to it.
 */
export const mapToScopePair = (input: ApiScopePair): ScopePair => ({
  platform: input.platform ? mapToPlatformReference(input.platform) : null,
  organization: input.federation ? mapToOrganizationReference(input.federation) : null,
});
